import { Link } from 'react-router-dom';

function TestNavigation() {
  const pages = [
    {
      category: 'Hotel Admin Pages',
      routes: [
        { path: '/dashboard', name: 'Hotel Admin Dashboard' },
        { path: '/employees', name: 'Employee Management' },
        { path: '/payroll', name: 'Payroll Management' },
        { path: '/rooms', name: 'Room Management' },
        { path: '/guests', name: 'Guest Management' },
        { path: '/bookings', name: 'Booking Management' },
        { path: '/hotel-payments', name: 'Payment Management' },
        { path: '/hotel-reports', name: 'Reports' },
      ],
    },
    {
      category: 'Super Admin Pages',
      routes: [
        { path: '/super-admin', name: 'Super Admin Dashboard' },
        { path: '/tenants', name: 'Tenant Management' },
        { path: '/system-payments', name: 'Payment Tracking' },
        { path: '/system-logs', name: 'System Logs' },
        { path: '/system-users', name: 'User Management' },
      ],
    },
    {
      category: 'Employee Pages',
      routes: [
        { path: '/employee-dashboard', name: 'Employee Dashboard' },
        { path: '/tasks', name: 'Task Management' },
        { path: '/schedule', name: 'Schedule' },
        { path: '/profile', name: 'Profile' },
      ],
    },
  ];

  return (
    <div className="py-10 px-6 max-w-5xl mx-auto">
      <div className="mb-10 text-center">
        <h1 className="text-3xl font-bold text-secondary-900 font-display mb-2.5">
          Test Navigation - All Pages
        </h1>
        <p className="text-secondary-500">
          Click any link below to test the pages we created
        </p>
      </div>

      {pages.map((section, idx) => (
        <div key={idx} className="bg-white p-6 sm:p-8 rounded-xl shadow-sm border border-secondary-200 mb-6">
          <h2 className="text-xl font-bold text-secondary-800 mb-5 pb-2.5 border-b-2 border-primary-500">
            {section.category}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {section.routes.map((route, routeIdx) => (
              <Link
                key={routeIdx}
                to={route.path}
                className="block px-5 py-4 bg-secondary-50 border border-secondary-200 rounded-lg text-sm font-medium text-secondary-800 transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500 hover:-translate-y-0.5"
              >
                {route.name}
              </Link>
            ))}
          </div>
        </div>
      ))}

      <div className="bg-amber-50 border border-amber-300 rounded-xl p-5 mt-6">
        <h3 className="text-base font-bold text-amber-800 mb-2">
          Testing Mode Active
        </h3>
        <p className="text-sm text-amber-700">
          Authentication is bypassed. You're automatically logged in as <strong>Hotel Admin</strong>.
          All pages are accessible without login for testing purposes.
        </p>
      </div>
    </div>
  );
}

export default TestNavigation;
